import backupSchedule from "./backupSchedule.component";
import backupScheduleUrls from "./backupSchedule.urls";
import BackupScheduleTransforms from "./backupSchedule.transforms";

const backupScheduleModule = angular
  .module("app.components.backupSchedule", [])
  .component("backupSchedulePage", backupSchedule)
  .service("BackupScheduleTransforms", BackupScheduleTransforms)
  .config(backupScheduleUrls);

export default backupScheduleModule;



// WEBPACK FOOTER //
// ./src/pages/backupSchedule/backupSchedule.module.js